<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="meter-history">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.kssj')">
              <el-date-picker
                v-model="startTime"
                type="date"
                :placeholder="$t('placeholder.kssj')"
                :picker-options="pickerOptionsStart"
                value-format="yyyy-MM-dd 00:00:00"
                @change="setTime($event)"
                @keyup.enter.native="getOverviewData"
              />
            </el-form-item>
            <el-form-item :label="$t('text.jssj')">
              <el-date-picker
                v-model="endTime"
                type="date"
                :placeholder="$t('placeholder.jssj')"
                :picker-options="pickerOptionsEnd"
                value-format="yyyy-MM-dd 23:59:59"
                @keyup.enter.native="getOverviewData"
              />
            </el-form-item>
            <el-form-item :label="$t('text.sbxlh')">
              <el-select
                v-if="select"
                v-model="gatewaysn"
                clearable
                :placeholder="$t('placeholder.qxxsb')"
                @keyup.enter.native="getOverviewData"
              >
                <el-option v-for="(item, index) in deviceList" :key="index" :label="item.key" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                style="background:#175E77;border:none"
                @click="getOverviewData"
              >{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div class="tool">
            <label>{{ $t('text.gnxz') }}</label>
            <el-checkbox-group v-model="checkedElemeter">
              <el-checkbox
                v-for="meter in elemeter"
                :key="meter.label"
                :label="meter"
                checked
                @change="valueChange(meter.val)"
              >{{ $t(meter.label) }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="chart-container">
            <line-chart
              :data="chart.data"
              :columns="chart.columns"
              :setting="chart.setting"
              :extend="chart.extend"
              :format="chart.format"
              :unit="chart.unit"
            />
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
import LineChart from '@/components/Charts/LineChart2.vue'
import { GetHistoryData } from '@/api/Meter'
import { GetDevicesByOrgId } from '@/api/Universal'
export default {
  name: 'History',
  components: {
    LineChart
  },
  data () {
    const curentDay = this.$parseTime(new Date(), 'yyyy-MM-dd 00:00:00')
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          return time.getTime() > new Date().getTime()
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (curentDay === this.startTime) {
            return time.getTime() < new Date(this.startTime) || time.getTime() > new Date(this.startTime)
          } else {
            return time.getTime() < new Date(this.startTime) || time.getTime() > new Date() || time.getTime() > new Date(this.startTime).getTime() + 1000 * 60 * 60 * 24 * 7
          }
        }
      },
      checkedElemeter: [
      ],
      isShow: false,
      select: false,
      elemeter: [
        { label: 'text.zxzdl', listProp: 'ftotal', val: 'ftotal', unit: 'kWh' },
        { label: 'text.fxzdl', listProp: 'rtotal', val: 'rtotal', unit: 'kWh' },
        { label: 'text.zyggl', listProp: 'pac', val: 'pac', unit: 'kW' },
        { label: 'text.zwggl', listProp: 'prc', val: 'prc', unit: 'kW' },
      ],
      chart: {
        data: [],
        unit: {},
        columns: ['createtime'],
        setting: { legendName: {}},
        format: ['yyyy-MM-dd hh:mm'],
        extend: {
          legend: {
            show: true,
            x: 'center',
            textStyle: {
              color: '#fff'
            }
          },
          yAxis: {
            position: 'left'
          },
          series: {
            type: 'line',
            showSymbol: false,
            smooth: true,
          },
          textStyle: {
            color: '#fff'
          }
        }
      },
      startTime: this.$parseTime(new Date(), 'yyyy-MM-dd 00:00:00'),
      endTime: this.$parseTime(new Date(), 'yyyy-MM-dd 23:59:59'),
      deviceList: [],
      gatewaysn: '',
      fullLoading: null,
    }
  },
  mounted () {
    this.getDeviceList().then(() => {
      this.getOverviewData()
    })
  },
  methods: {
    getDeviceList () {
      return new Promise((resolve, reject) => {
        GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' })
          .then(response => {
            this.deviceList = response.data || []
            this.select = true
            this.gatewaysn = this.deviceList[0].value || null
            resolve()
          }).catch(() => {
            reject()
          })
      })
    },
    getOverviewData () {
      if (!this.gatewaysn) {
        this.$msgWarning(this.$t('notice.sblbwk'))
      } else if (!this.checkedElemeter.length) {
        this.$msgWarning(this.$t('notice.zsyg'))
      } else {
        this.fullLoading = this.$loading({
          lock: true,
          text: 'loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, .7)',
        })
        GetHistoryData({
          deviceId: this.gatewaysn,
          startTime: this.startTime,
          endTime: this.endTime
        }).then(({ data }) => {
          this.getHistoryDataCall(data)
          this.isShow = true
        }).finally(() => {
          this.fullLoading.close()
        })
      }
    },
    getHistoryDataCall (response) {
      this.elemeter.map(value => {
        this.chart.unit[value.val] = { unit: value.unit, label: this.$t(value.label) }
      })
      this.chart.data = response || []
      this.chart.columns = JSON.parse(JSON.stringify(['createtime'].concat(this.checkedElemeter.map(value => {
        return value.val
      }))))
      this.checkedElemeter.map(({ label, listProp }) => {
        this.chart.setting.legendName[`${listProp}`] = `${this.$t(label)}`
      })
    },
    setTime (val) {
      this.endTime = this.startTime === val ? null : this.endTime
    },
    valueChange () {
      const columns = ['createtime']
      const chooseArray = this.checkedElemeter.map(value => value.val)
      this.elemeter.map(value => value.val).map(value => {
        if (chooseArray.includes(value)) {
          columns.push(value)
        }
      })
      this.chart.columns = JSON.parse(JSON.stringify(columns))
    }
  }
}
</script>
<style scoped>
.meter-history {
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: var(--card-bg-color);
  border: none;
  box-sizing: border-box;
}

.meter-history >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.meter-history >>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-history >>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.meter-history >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 10px 20px 0;
  box-sizing: border-box;
}
.meter-history >>> .el-card__body .tool{
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-history >>> .el-card__body .tool label{
  margin: 0 10px 5px 0;
  color: var(--primary-color);
}

.meter-history >>> .el-card__body .chart-container{
  width: 100%;
  height: calc(100% - 50px);
  padding: 10px 0;
  box-sizing: border-box;
}

</style>
